import React, { memo } from 'react';
import { SubsidiaryHeader } from '../../../components/shared/SubsidiaryHeader';
import { SubsidiaryFooter } from '../../../components/shared/SubsidiaryFooter';
import { Link } from 'react-router-dom';
const navigation = [{
  name: 'Home',
  href: '/palace-hotel'
}, {
  name: 'Rooms & Suites',
  href: '/palace-hotel/rooms'
}, {
  name: 'Dining',
  href: '/palace-hotel/dining'
}, {
  name: 'Spa & Wellness',
  href: '#'
}, {
  name: 'Meetings & Events',
  href: '#'
}, {
  name: 'Contact',
  href: '#contact'
}];
const footerLinks = [{
  title: 'Accommodations',
  items: [{
    name: 'Deluxe Rooms',
    href: '#'
  }, {
    name: 'Executive Suites',
    href: '#'
  }, {
    name: 'Presidential Suite',
    href: '#'
  }, {
    name: 'Special Offers',
    href: '#'
  }]
}, {
  title: 'Experiences',
  items: [{
    name: 'Fine Dining',
    href: '#'
  }, {
    name: 'Spa Treatments',
    href: '#'
  }, {
    name: 'Fitness Center',
    href: '#'
  }, {
    name: 'Events & Weddings',
    href: '#'
  }]
}];
export function PalaceHotelHome() {
  return <div className="flex flex-col min-h-screen" data-id="element-658">
      <SubsidiaryHeader name="Solochus Palace Hotel" color="bg-amber-50 text-amber-900" navigation={navigation} logo="https://uploadthingy.s3.us-west-1.amazonaws.com/iUXecTUoL9PBBs7nqvYwnz/SOLO_hotel.png" data-id="element-659" />
      <main className="flex-grow" data-id="element-660">
        {/* Hero Section */}
        <section className="relative h-[70vh]" data-id="element-661">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center" data-id="element-662"></div>
          <div className="absolute inset-0 bg-black/30" data-id="element-663"></div>
          <div className="relative z-10 container mx-auto px-4 h-full flex items-center" data-id="element-664">
            <div className="max-w-xl text-white" data-id="element-665">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-666">
                Experience Luxury Redefined
              </h1>
              <p className="text-xl md:text-2xl mb-8" data-id="element-667">
                Where elegance meets exceptional service. Your perfect getaway
                awaits.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-668">
                <Link to="/palace-hotel/rooms" className="px-6 py-3 bg-amber-600 text-white font-medium rounded-md hover:bg-amber-700 transition-colors" data-id="element-669">
                  Book a Room
                </Link>
                <a href="#explore" className="px-6 py-3 bg-transparent border border-white text-white font-medium rounded-md hover:bg-white/10 transition-colors" data-id="element-670">
                  Explore Hotel
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Features Section */}
        <section id="explore" className="py-20" data-id="element-671">
          <div className="container mx-auto px-4" data-id="element-672">
            <h2 className="text-3xl font-bold text-center mb-16" data-id="element-673">
              Experience the Palace Difference
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-674">
              <div className="bg-amber-50 p-8 rounded-lg text-amber-900" data-id="element-675">
                <div className="text-4xl mb-4" data-id="element-676">🏨</div>
                <h3 className="text-xl font-bold mb-2" data-id="element-677">
                  Luxurious Accommodations
                </h3>
                <p className="mb-4" data-id="element-678">
                  Elegantly appointed rooms and suites with stunning views and
                  premium amenities.
                </p>
                <Link to="/palace-hotel/rooms" className="text-amber-700 font-medium hover:text-amber-800" data-id="element-679">
                  View Rooms →
                </Link>
              </div>
              <div className="bg-amber-50 p-8 rounded-lg text-amber-900" data-id="element-680">
                <div className="text-4xl mb-4" data-id="element-681">🍽️</div>
                <h3 className="text-xl font-bold mb-2" data-id="element-682">Exquisite Dining</h3>
                <p className="mb-4" data-id="element-683">
                  Culinary masterpieces prepared by world-class chefs in our
                  award-winning restaurants.
                </p>
                <Link to="/palace-hotel/dining" className="text-amber-700 font-medium hover:text-amber-800" data-id="element-684">
                  Discover Dining →
                </Link>
              </div>
              <div className="bg-amber-50 p-8 rounded-lg text-amber-900" data-id="element-685">
                <div className="text-4xl mb-4" data-id="element-686">💆</div>
                <h3 className="text-xl font-bold mb-2" data-id="element-687">Spa & Wellness</h3>
                <p className="mb-4" data-id="element-688">
                  Rejuvenate your body and mind with our premium spa services
                  and wellness facilities.
                </p>
                <a href="#" className="text-amber-700 font-medium hover:text-amber-800" data-id="element-689">
                  Explore Spa →
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Special Offers Section */}
        <section className="py-20 bg-amber-100" data-id="element-690">
          <div className="container mx-auto px-4" data-id="element-691">
            <h2 className="text-3xl font-bold text-center text-amber-900 mb-16" data-id="element-692">
              Special Offers
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-693">
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-694">
                <h3 className="text-xl font-bold text-amber-800 mb-2" data-id="element-695">
                  Weekend Escape Package
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-696">
                  Enjoy a luxurious weekend getaway with complimentary breakfast
                  and spa credits.
                </p>
                <ul className="mb-6 text-gray-700" data-id="element-697">
                  <li className="flex items-center mb-2" data-id="element-698">
                    <span className="mr-2" data-id="element-699">✓</span>
                    Luxury accommodation
                  </li>
                  <li className="flex items-center mb-2" data-id="element-700">
                    <span className="mr-2" data-id="element-701">✓</span>
                    Daily breakfast for two
                  </li>
                  <li className="flex items-center mb-2" data-id="element-702">
                    <span className="mr-2" data-id="element-703">✓</span>
                    $100 spa credit
                  </li>
                  <li className="flex items-center" data-id="element-704">
                    <span className="mr-2" data-id="element-705">✓</span>
                    Late checkout at 2 PM
                  </li>
                </ul>
                <div className="flex justify-between items-end" data-id="element-706">
                  <div data-id="element-707">
                    <span className="text-2xl font-bold text-amber-800" data-id="element-708">
                      $299
                    </span>
                    <span className="text-gray-600" data-id="element-709"> / night</span>
                  </div>
                  <a href="#" className="px-4 py-2 bg-amber-600 text-white rounded-md hover:bg-amber-700 transition-colors" data-id="element-710">
                    Book Now
                  </a>
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-711">
                <h3 className="text-xl font-bold text-amber-800 mb-2" data-id="element-712">
                  Family Fun Package
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-713">
                  Create unforgettable memories with activities for the whole
                  family.
                </p>
                <ul className="mb-6 text-gray-700" data-id="element-714">
                  <li className="flex items-center mb-2" data-id="element-715">
                    <span className="mr-2" data-id="element-716">✓</span>
                    Connecting rooms
                  </li>
                  <li className="flex items-center mb-2" data-id="element-717">
                    <span className="mr-2" data-id="element-718">✓</span>
                    Daily breakfast for four
                  </li>
                  <li className="flex items-center mb-2" data-id="element-719">
                    <span className="mr-2" data-id="element-720">✓</span>
                    Kids' welcome amenities
                  </li>
                  <li className="flex items-center" data-id="element-721">
                    <span className="mr-2" data-id="element-722">✓</span>
                    One complimentary family activity
                  </li>
                </ul>
                <div className="flex justify-between items-end" data-id="element-723">
                  <div data-id="element-724">
                    <span className="text-2xl font-bold text-amber-800" data-id="element-725">
                      $399
                    </span>
                    <span className="text-gray-600" data-id="element-726"> / night</span>
                  </div>
                  <a href="#" className="px-4 py-2 bg-amber-600 text-white rounded-md hover:bg-amber-700 transition-colors" data-id="element-727">
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Testimonials Section */}
        <section className="py-20" data-id="element-728">
          <div className="container mx-auto px-4" data-id="element-729">
            <h2 className="text-3xl font-bold text-center mb-16" data-id="element-730">
              Guest Experiences
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-731">
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-732">
                <div className="flex items-center mb-4" data-id="element-733">
                  <div className="text-amber-500" data-id="element-734">★★★★★</div>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-735">
                  "An exceptional experience from start to finish. The staff
                  went above and beyond to make our stay memorable."
                </p>
                <div className="font-medium" data-id="element-736">
                  <p className="text-amber-800" data-id="element-737">Sarah J.</p>
                  <p className="text-gray-600 text-sm" data-id="element-738">New York, USA</p>
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-739">
                <div className="flex items-center mb-4" data-id="element-740">
                  <div className="text-amber-500" data-id="element-741">★★★★★</div>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-742">
                  "The room was immaculate, the views stunning, and the food at
                  the restaurant was world-class. We'll definitely return!"
                </p>
                <div className="font-medium" data-id="element-743">
                  <p className="text-amber-800" data-id="element-744">David M.</p>
                  <p className="text-gray-600 text-sm" data-id="element-745">London, UK</p>
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-746">
                <div className="flex items-center mb-4" data-id="element-747">
                  <div className="text-amber-500" data-id="element-748">★★★★★</div>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-749">
                  "The spa treatments were absolutely divine. I left feeling
                  completely rejuvenated and pampered."
                </p>
                <div className="font-medium" data-id="element-750">
                  <p className="text-amber-800" data-id="element-751">Michelle T.</p>
                  <p className="text-gray-600 text-sm" data-id="element-752">Toronto, Canada</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Contact Section */}
        <section id="contact" className="py-20 bg-amber-50" data-id="element-753">
          <div className="container mx-auto px-4" data-id="element-754">
            <h2 className="text-3xl font-bold text-center text-amber-900 mb-16" data-id="element-755">
              Contact Us
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-756">
              <div data-id="element-757">
                <h3 className="text-xl font-bold text-amber-800 mb-4" data-id="element-758">
                  Reservation Inquiries
                </h3>
                <p className="text-gray-700 mb-6" data-id="element-759">
                  For reservations or inquiries, our dedicated team is ready to
                  assist you 24/7.
                </p>
                <div className="space-y-4 mb-8" data-id="element-760">
                  <div className="flex items-start" data-id="element-761">
                    <span className="text-amber-600 mr-4" data-id="element-762">📞</span>
                    <div data-id="element-763">
                      <p className="font-medium" data-id="element-764">Phone</p>
                      <p className="text-gray-600" data-id="element-765">+234 123 456 7890</p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-766">
                    <span className="text-amber-600 mr-4" data-id="element-767">✉️</span>
                    <div data-id="element-768">
                      <p className="font-medium" data-id="element-769">Email</p>
                      <p className="text-gray-600" data-id="element-770">
                        reservations@solochuspalace.com
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-771">
                    <span className="text-amber-600 mr-4" data-id="element-772">📍</span>
                    <div data-id="element-773">
                      <p className="font-medium" data-id="element-774">Address</p>
                      <p className="text-gray-600" data-id="element-775">
                        123 Luxury Avenue
                        <br data-id="element-776" />
                        Victoria Island, Lagos
                        <br data-id="element-777" />
                        Nigeria
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-778">
                <form className="bg-white p-6 rounded-lg shadow-md" data-id="element-779">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-780">
                    <div data-id="element-781">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-782">
                        Name
                      </label>
                      <input type="text" id="name" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none" data-id="element-783" />
                    </div>
                    <div data-id="element-784">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-785">
                        Email
                      </label>
                      <input type="email" id="email" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none" data-id="element-786" />
                    </div>
                  </div>
                  <div className="mb-4" data-id="element-787">
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-788">
                      Subject
                    </label>
                    <input type="text" id="subject" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none" data-id="element-789" />
                  </div>
                  <div className="mb-4" data-id="element-790">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-791">
                      Message
                    </label>
                    <textarea id="message" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none" data-id="element-792"></textarea>
                  </div>
                  <button type="submit" className="w-full py-2 px-4 bg-amber-600 text-white font-medium rounded-md hover:bg-amber-700 transition-colors" data-id="element-793">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SubsidiaryFooter name="Solochus Palace Hotel" description="Experience luxury and exceptional service at Lagos' premier hotel destination." color="bg-amber-900" textColor="text-white" links={footerLinks} logo="https://uploadthingy.s3.us-west-1.amazonaws.com/iUXecTUoL9PBBs7nqvYwnz/SOLO_hotel.png" data-id="element-794" />
    </div>;
}